import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

// Preview sandbox flag (server decides; never on in production). Fetched once per page load.
let cached = null;
const load = () => (cached ||= api.get("/sandbox", { headers: { "X-Background": "1" } }).then((r) => !!r.data?.active).catch(() => false));

export function useSandbox() {
  const [on, setOn] = useState(false);
  useEffect(() => { let live = true; load().then((v) => { if (live) setOn(v); }); return () => { live = false; }; }, []);
  return on;
}

export const SandboxBanner = ({ testId = "sandbox-banner" }) => (
  <p data-testid={testId} className="text-xs font-semibold text-[#78350F] bg-[#FEF3C7] border border-[#FCD34D] rounded-lg px-2.5 py-1.5">
    Preview sandbox — full functionality on every horse. No emails, texts, posts or QuickBooks actions reach sellers.
  </p>
);

const err = (e) => e?.response?.data?.detail || "Something went wrong";

// Preview only: builds a complete sample horse through the real application → approval → signing → sale flow.
export function SampleHorseTools({ onCreated, onRemoved }) {
  const [busy, setBusy] = useState("");
  const run = async (k, fn) => { setBusy(k); try { await fn(); } catch (e) { toast.error(err(e)); } finally { setBusy(""); } };
  const create = () => run("create", async () => {
    const { data } = await api.post("/sandbox/sample-horse");
    toast.success(`${data.name} created — opening Accounting`); onCreated?.(data.horse_id);
  });
  const remove = () => run("remove", async () => {
    if (!window.confirm("Remove every sample horse made with this button? Other horses are not touched.")) return;
    const { data } = await api.delete("/sandbox/sample-horses");
    toast.success(`${data.removed} sample horse(s) removed`); onRemoved?.();
  });
  return (
    <div data-testid="sandbox-sample-tools" className="flex flex-wrap gap-2 mt-2">
      <Button data-testid="sandbox-create-sample-horse" size="sm" disabled={!!busy} onClick={create} className="rounded-full">{busy === "create" ? "Creating sample horse…" : "Create sample horse"}</Button>
      <Button data-testid="sandbox-remove-sample-horses" size="sm" variant="outline" disabled={!!busy} onClick={remove} className="rounded-full">{busy === "remove" ? "Removing…" : "Remove sample horses"}</Button>
    </div>
  );
}
